import { ELeaveStatus, ELeaveTransactionType, EPaymentStatus, EStatus } from "@/Core/enums";

export const shippingStatuses = {
    Approved: "Approved",
    InTransit: "In Transit",
    OutForDelivery: "Out For Delivery",
    Delivered: "Delivered",
    DeliveryFailed: "Delivery Failed",
};

export function getStatusColors(status: string) {
    if (shippingStatuses.Approved === status) {
        return "success";
    }
    if (shippingStatuses.InTransit === status) {
        return "secondary";
    }
    if (shippingStatuses.OutForDelivery === status) {
        return "info";
    }
    if (shippingStatuses.Delivered === status) {
        return "success";
    }
    if (shippingStatuses.DeliveryFailed === status) {
        return "danger";
    }
}

export function getUserStatusColors(status: EStatus): [string, string] {
    if (
        EStatus.Active === status ||
        EStatus.Success === status ||
        EStatus.Done === status
    ) {
        return [
            "text-green-dark dark:text-green-500",
            "bg-green-dark dark:bg-green-500",
        ];
    }
    if (EStatus.Failed === status || EStatus.Warning === status) {
        return ["text-orange-dark", "bg-orange-dark"];
    }
    if (
        EStatus.Waiting === status ||
        EStatus.Dispatch === status ||
        EStatus.InProgress === status
    ) {
        return ["text-teal-600", "bg-teal-600"];
    }
    if (EStatus.Accepted === status || EStatus.Delivered === status) {
        return ["text-blue-dark", "bg-blue-dark"];
    }
    if (
        EStatus.OnTheWay === status ||
        EStatus.CheckedIn === status ||
        EStatus.Processing === status
    ) {
        return ["text-indigo-600", "bg-indigo-600"];
    }
    if (
        EStatus.Blocked === status ||
        EStatus.Cancel === status ||
        EStatus.CheckedOut === status ||
        EStatus.Reject === status
    ) {
        return ["text-rose-600", "bg-rose-600"];
    }

    return ["text-gray-600", "bg-gray-600"];
}

export function getEventStatusColors(status: EStatus): [string, string] {
    if (EStatus.Approved === status) {
        return [
            "text-green-dark dark:text-green-500",
            "bg-green-dark dark:bg-green-500",
        ];
    }

    if (EStatus.Done === status) {
        return ["text-teal-600", "bg-teal-600"];
    }

    if (EStatus.Pending === status) {
        return ["text-blue-dark", "bg-blue-dark"];
    }

    if (status === EStatus.Accepted) {
        return ["text-red-600", "bg-red-600"];
    }

    return ["text-gray-600", "bg-gray-600"];
}

export function getPaymentStatusColors(status: EPaymentStatus): [string, string] {
    if (EPaymentStatus.Paid === status) {
        return [
            "text-green-dark dark:text-green-500",
            "bg-green-dark dark:bg-green-500",
        ];
    }

    if (EPaymentStatus.Processing === status) {
        return ["text-teal-600", "bg-teal-600"];
    }

    if (EPaymentStatus.Pending === status) {
        return ["text-blue-dark", "bg-blue-dark"];
    }

    if (status === EPaymentStatus.Canceled) {
        return ["text-red-600", "bg-red-600"];
    }

    return ["text-gray-600", "bg-gray-600"];
}

export function getLeaveTypeColors(
    type: ELeaveTransactionType,
): [string, string] {
    if (ELeaveTransactionType.Added === type) {
        return [
            "text-green-dark dark:text-green-500",
            "bg-green-dark dark:bg-green-500",
        ];
    }

    if (ELeaveTransactionType.Expired === type) {
        return ["text-rose-600", "bg-rose-600"];
    }
    if (ELeaveTransactionType.Modification === type) {
        return ["text-blue-dark", "bg-blue-dark"];
    }
    if (ELeaveTransactionType.Cancellation === type) {
        return ["text-red-600", "bg-red-600"];
    }

    if (ELeaveTransactionType.Rescheduled === type) {
        return ["text-amber-600", "bg-amber-600"];
    }

    if (ELeaveTransactionType.Deducted === type) {
        return ["text-lime-600", "bg-lime-600"];
    }

    return ["text-gray-600", "bg-gray-600"];
}

